import { render, staticRenderFns } from "./IconHouseUp.vue?vue&type=template&id=47b9c1af&"
import script from "./IconHouseUp.vue?vue&type=script&lang=ts&"
export * from "./IconHouseUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports